import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState } from 'react';
import { get } from '@cullylarson/f';
import { preventDefault } from '@@client/lib/events';
import { formatPhone } from '@@client/lib/util';
import Messages from '@@client/components/Messages';
import FormPhone from '@@client/components/FormPhone';
import StepSummaryItem from './StepSummaryItem';
import NextStepButton from './NextStepButton';
export default function StepUserContact(_ref) {
  var _ref$contactPhone = _ref.contactPhone,
      contactPhone = _ref$contactPhone === void 0 ? '' : _ref$contactPhone,
      showSummary = _ref.showSummary,
      onSubmit = _ref.onSubmit,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      _ref$paramErrors = _ref.paramErrors,
      paramErrors = _ref$paramErrors === void 0 ? {} : _ref$paramErrors;

  var _useState = useState(contactPhone),
      phone = _useState[0],
      setPhone = _useState[1];

  var _useState2 = useState([]),
      phoneErrors = _useState2[0],
      setPhoneErrors = _useState2[1];

  var idPrefix = 'checkout-user-contact';

  var handleParam = function handleParam(setParam) {
    return function (e) {
      return e && e.target ? setParam(e.target.value) : setParam(e);
    };
  };

  var handleSubmit = preventDefault(function () {
    var foundErrors = false;

    if (!phone) {
      setPhoneErrors(['Please provide a phone number.']);
      foundErrors = true;
    } else {
      setPhoneErrors([]);
    }

    if (!foundErrors) {
      onSubmit({
        contactPhone: phone
      });
    }
  });

  if (showSummary) {
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(StepSummaryItem, {
        title: "Contact Phone",
        children: formatPhone(contactPhone)
      })
    });
  } else {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Messages, {
        error: errors
      }), /*#__PURE__*/_jsx("p", {
        className: "jsx-1608088591",
        children: "Since we don't have a phone number on file for your account, we'll need to get that from you."
      }), /*#__PURE__*/_jsxs("form", {
        onSubmit: handleSubmit,
        className: "jsx-1608088591",
        children: [/*#__PURE__*/_jsx("div", {
          className: "jsx-1608088591" + " " + 'fields-wrapper',
          children: /*#__PURE__*/_jsx(FormPhone, {
            idPrefix: idPrefix,
            name: "phone",
            title: "Contact Phone",
            value: phone,
            onChange: handleParam(setPhone),
            errors: phoneErrors.concat(get('contactPhone', [], paramErrors)),
            required: true,
            autoComplete: "tel"
          })
        }), /*#__PURE__*/_jsx(NextStepButton, {
          disabled: disabled,
          children: "Next: Shipping Info"
        })]
      }), /*#__PURE__*/_jsx(_JSXStyle, {
        id: "1608088591",
        children: [".fields-wrapper.jsx-1608088591{max-width:350px;margin:0 auto;}"]
      })]
    });
  }
}